import assetIcFilter from './ic-filter.svg';
export enum FilterIconName {
  Filter = 'Filter',
}

export const filterIconAssets: {[key in FilterIconName]: string} = {
  [FilterIconName.Filter]: assetIcFilter,
};
